function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M21.5 8.37v7.45c0 .15-.05.3-.18.43l-5.51 5.55c-.13.14-.3.2-.47.2H7.37a4.87 4.87 0 01-4.87-4.87V8.37A4.87 4.87 0 017.37 3.5h9.26a4.87 4.87 0 014.87 4.87z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.29 6.29c-.42 0-.75-.34-.75-.75V2.75a.749.749 0 111.5 0v2.78c0 .42-.33.76-.75.76zm7.42 0c-.42 0-.75-.34-.75-.75V2.75a.749.749 0 111.5 0v2.78c0 .42-.33.76-.75.76zm-.93 6.42H7.36a.749.749 0 110-1.5h7.42a.749.749 0 110 1.5zM12 16.42H7.36a.749.749 0 110-1.5H12a.749.749 0 110 1.5zm9.5-.6c0 .15-.05.3-.18.43l-5.51 5.55c-.13.14-.3.2-.47.2-.33 0-.65-.26-.65-.64v-3.5c0-1.46 1.24-2.67 2.76-2.67.95-.01 2.27-.01 3.4-.01.39 0 .65.31.65.64z"
})));